import client from "../Client/HttpClient";
import {ITeachersModel} from "@/interfaces/modules";
const ApiPath = "Teachers";

export default {
    GetTeachers:() : Promise <ITeachersModel[]> => client.get(`${ApiPath}`),
    GetTeachersbyId: (data: any): Promise <ITeachersModel> => client.get(`${ApiPath}/${data.Id}`), 
    PostTeachers: (data: any): Promise<ITeachersModel> => client.post(`${ApiPath}`, data)
  };